import { render } from "./square-button.vue?vue&type=template&id=3a80ef12&scoped=true"
import script from "./square-button.vue?vue&type=script&lang=js"
export * from "./square-button.vue?vue&type=script&lang=js"

import "./square-button.vue?vue&type=style&index=0&id=3a80ef12&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a80ef12"]])

export default __exports__